"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_otp_input_1 = require("react-otp-input");
const react_1 = require("react");
const theme_1 = require("../../theme");
const icons_material_1 = require("@mui/icons-material");
const Label_1 = require("../../components/Label");
const OtpInput = (_a) => {
    var { onChange, error, label } = _a, rest = __rest(_a, ["onChange", "error", "label"]);
    const [value, setValue] = (0, react_1.useState)('');
    const handleChange = (otp) => {
        setValue(otp);
        onChange(otp);
    };
    return ((0, jsx_runtime_1.jsxs)(Label_1.default, { label: label, hasError: error, style: {
            '& .inputContainer': {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            },
        }, children: [(0, jsx_runtime_1.jsx)(react_otp_input_1.default, Object.assign({ inputStyle: { fontSize: '1.5rem' }, value: value, shouldAutoFocus: true, onChange: handleChange, renderSeparator: (0, jsx_runtime_1.jsx)("span", { style: { width: '12px' } }), renderInput: (props) => (0, jsx_runtime_1.jsx)("input", Object.assign({}, props, { autoComplete: "one-time-code" })) }, rest)), (0, jsx_runtime_1.jsx)(icons_material_1.HighlightOffOutlined, { sx: {
                    position: 'absolute',
                    right: '12px',
                    width: '20px',
                    height: '20px',
                    color: error && value.length > 0
                        ? theme_1.theme.qlub.palette.danger.main
                        : value.length > 0
                            ? theme_1.theme.qlub.palette.onSurfaceColors.mediumEmphasis
                            : theme_1.theme.qlub.palette.onSurfaceColors.disabled,
                    cursor: value.length > 0 ? 'pointer' : 'default',
                }, onClick: (e) => {
                    handleChange('');
                    e.stopPropagation();
                } })] }));
};
exports.default = OtpInput;
